import { useContext } from 'react';
import { FilterDataContext } from '../contexts/filterDataContext';

const useFilterData = () => {
  const value = useContext(FilterDataContext);

  return value;
};

export default useFilterData;
